var $0c9eac180fa864f5$exports = {};
$0c9eac180fa864f5$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigat\xf3rio)`
};


export {$0c9eac180fa864f5$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
